import { useState } from "react";
import { loadVendorEnquiryDetWithPartyList } from "../services/vendorEnquiryService";

const useGetVendorEnquiryDetByPurchaseID = () => {

    const [vendorEnquiryDet, setvendorEnquiryDet] = useState([]);

    const fetchVendorEnquiryDetail = async (purchaseid = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_purchase: purchaseid,
        };

        try {
            const data = await loadVendorEnquiryDetWithPartyList(para);

            if (Array.isArray(data)) {
                setvendorEnquiryDet(data);
                return data; // 🔥 IMPORTANT
            }

            setvendorEnquiryDet([]);
            return [];

        } catch (error) {
            setvendorEnquiryDet([]);
            return [];
        }
    };

    const loadVendorEnquiryDet = async (purchaseid) => {
        return await fetchVendorEnquiryDetail(purchaseid); // 🔥 RETURN
    };

    return {
        vendorEnquiryDet,
        setvendorEnquiryDet,
        loadVendorEnquiryDet
    };
};

export default useGetVendorEnquiryDetByPurchaseID;
